import { FiEdit } from "react-icons/fi";

export default function AddressCard({
  address,
  selected,
  onSelect,
  onEdit,
}) {

  return (
      <div
          onClick={() => onSelect(address)}
          className={`
    relative border rounded-2xl p-5 cursor-pointer transition-all duration-200
    hover:border-blue-300 hover:shadow-sm
    ${selected
              ? "border-blue-500 bg-blue-50 shadow-sm"
              : "border-gray-200 bg-white"}
  `}
      >

        <div className="flex justify-between items-start gap-4">

          <div className="flex-1">

            {/* title + city */}
            <div className="flex items-center flex-wrap gap-2">

              <h3 className="font-bold text-gray-800 text-base">
                {address.title}
              </h3>

              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
          {address.province_detail} - {address.city_detail}
        </span>

            </div>

            {/* address */}
            <p className="text-sm text-gray-600 mt-3 leading-7">
              {address.address_text}
            </p>

          </div>

          {/* edit button */}
          <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit(address);
              }}
              className="
        p-2 rounded-lg
        text-green-600
        hover:bg-green-50
        transition
      "
          >
            <FiEdit className="w-4 h-4"/>
          </button>

        </div>
      </div>

  );
}
